/* eslint-disable */
import React from 'react';
import logo from '../../images/SideBarImg/Knowledge_white.png';
import controlLogo from '../../images/SideBarImg/CC_white.png';
import directTaxLogo from '../../images/SideBarImg/DT_white.png';
import idtLogo from '../../images/SideBarImg/IDT_white.png';
import legalLogo from '../../images/SideBarImg/Legal_white.png';


export const KnowledgeLogoIcon = ({ size = 24 }) => (
  <img src={logo} alt="Knowledge Logo" style={{ width: size, height: size }} />
);


export const ControlLogoIcon = ({ size = 24 }) => (
  <img src={controlLogo} alt="Control & Compliance" style={{ width: size, height: size }} />
);


export const DirectTaxLogoIcon = ({ size = 24 }) => (
  <img src={directTaxLogo} alt="Direct Tax" style={{ width: size, height: size }} />
);


export const IdtLogoIcon = ({ size = 24 }) => (
  <img src={idtLogo} alt="Indirect Tax" style={{ width: size, height: size }} />
);


export const LegalLogoIcon = ({ size = 24 }) => (
  <img src={legalLogo} alt="Legal" style={{ width: size, height: size }} />
);
